import AuthenticateUser from "../AuthenticateUser";
import {RequestActionsConstant} from "./RequestActionsConstant";
import RequestBase from "./RequestBase";

export default class SessionRequest extends RequestBase {
    constructor(
        public readonly authenicateUser: AuthenticateUser,
        public readonly bnsToken: string,
        public readonly selectedOrganizationId: number | null,
        public readonly enforceNewSession: boolean = false,
    ) {
        super();
        this.action = RequestActionsConstant.GET_SESSION;
    }
}
